import React, { useEffect, useState } from 'react';
import generateRowHeader from '../../../../component/data-table-container/utils/generate-row-header';
import globalProgramStore from '../../../../stores/program-store';
import CallToActionButton from '../../../../component/call-to-action-button/call-to-action-button';
import { Dialog } from 'primereact/dialog';
import { DialogAddNewServiceToProgram } from './componenets/dialog-add-new-service-to-program';
import { PaymentServiceWithVersionsResponseType } from '../../../../api/types/payments/payment-template';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import globalConfigStore from '../../../../stores/global-config-store';
import { deletePaymentServiceOperation } from './operations/delete-payment-service-operation';
import { ProgramPaymentService } from '../../../../api/types/programs/payments/program-payment-with-price';
import { Accordion, AccordionTab } from 'primereact/accordion';
import globalSettingsBranches from '../../../../stores/global-settings-branches';
import { Tag } from 'primereact/tag';

// Interface for year-based payment services structure
interface YearPaymentServices {
  year: number;
  yearName: string;
  services: PaymentServiceWithVersionsResponseType[];
}

const ProgramServicesTab = () => {
  const [displayAddServiceDialog, setDisplayAddServiceDialog] = useState(false);
  const [yearServices, setYearServices] = useState<YearPaymentServices[]>([]);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [paymentServiceId, setPaymentServiceId] = useState<number | null>(null);

  const currentProgram = globalProgramStore.programs.get(
    globalProgramStore.getCurrentId() ?? -1,
  );

  useEffect(() => {
    const program = globalProgramStore.programs.get(
      globalProgramStore.getCurrentId() ?? -1,
    );

    if (program?.details?.years) {
      const formattedYearServices = program.details.years.map((yearData) => ({
        year: yearData.year,
        yearName: `שנה ${yearData.year === 0 ? 'א׳' : yearData.year === 1 ? 'ב׳' : 'ג׳'}`,
        services: yearData.paymentServices || [],
      }));

      setYearServices(formattedYearServices);
    }
  }, [globalProgramStore.version]);

  const closeDialog = () => {
    setDisplayAddServiceDialog(false);
    setSelectedYear(null);
  };

  const handleServiceDelete = async (
    programPaymentServiceId: number,
    year: number,
  ) => {
    const branchId = globalConfigStore.rootFilter.currentBranches?.id;
    const currentProgramId = globalProgramStore.getCurrentId();

    await deletePaymentServiceOperation(
      branchId,
      currentProgramId,
      year,
      programPaymentServiceId,
      setPaymentServiceId,
    );
  };

  const handleAddServiceClick = (year: number) => {
    setSelectedYear(year);
    setDisplayAddServiceDialog(true);
  };

  const renderYearServicesTable = (
    services: PaymentServiceWithVersionsResponseType[],
    year: number,
  ) => (
    <DataTable
      emptyMessage={
        <div style={{ textAlign: 'right' }}>לא נמצאו שירותים בשנה זו</div>
      }
      value={services}
      dataKey="id"
      tableStyle={{
        direction: 'rtl',
        marginTop: '8px',
      }}
    >
      <Column
        style={{ textAlign: 'right' }}
        field="paymentServiceName"
        header="שם שרות"
      />
      <Column
        field="מחיר"
        header="מחיר"
        style={{ textAlign: 'right' }}
        body={(rowData: PaymentServiceWithVersionsResponseType) => {
          return (
            <div>
              ₪
              {
                rowData.versions.find((item) => item.id === rowData.versionId)
                  ?.price
              }
            </div>
          );
        }}
      />
      <Column
        style={{ textAlign: 'right' }}
        field="נשלח ע״י"
        header=""
        body={(rowData: ProgramPaymentService) => (
          <Button
            id={`delete-button`}
            icon="pi pi-trash"
            text
            severity="danger"
            tooltip={'מחיקת שרות'}
            loading={paymentServiceId === rowData.id}
            disabled={paymentServiceId !== null}
            onClick={async (e) => {
              e.stopPropagation();
              await handleServiceDelete(rowData.programPaymentId, year);
            }}
          />
        )}
      />
    </DataTable>
  );

  return (
    <div className="program-services-container">
      <Accordion multiple>
        {yearServices.map((yearData) => (
          <AccordionTab
            key={yearData.year}
            header={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '8px',
                    alignItems: 'center',
                  }}
                >
                  <span>{yearData.yearName}</span>
                  {globalSettingsBranches.workingTimeManagement
                    ?.currentWorkingYear ===
                    yearData.year +
                      currentProgram.metadata.programStartYear && (
                    <Tag
                      style={{
                        height: '22.5px',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '90px',
                      }}
                    >
                      שנה נוכחית
                    </Tag>
                  )}
                </div>
                <Button
                  style={{ height: '30px', width: '30px' }}
                  icon="pi pi-plus"
                  tooltip="הוספת שירות תשלום"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddServiceClick(yearData.year);
                  }}
                />
              </div>
            }
          >
            {renderYearServicesTable(yearData.services, yearData.year)}
          </AccordionTab>
        ))}
      </Accordion>

      <Dialog
        header={`הוספת שירות ${selectedYear !== null ? `לשנה ${selectedYear === 0 ? 'א׳' : selectedYear === 1 ? 'ב׳' : 'ג׳'}` : ''}`}
        visible={displayAddServiceDialog}
        style={{
          height: '80vh',
          width: '90wh',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={closeDialog}
      >
        {selectedYear !== null && (
          <DialogAddNewServiceToProgram
            selectedYear={selectedYear}
            closeDialog={closeDialog}
          />
        )}
      </Dialog>
    </div>
  );
};

export default ProgramServicesTab;
